import React from "react";

type IsWireComponentInCollection = false | { hasAction: boolean; onClick: () => void };
export const IsWireComponentInCollectionContext = React.createContext<IsWireComponentInCollection>(false);

export const useWireComponentInCollection = () => React.useContext(IsWireComponentInCollectionContext);
